export const FAMILY_TYPE_EXTEND = 'extend';
export const FAMILY_TYPE_SIMPLE = 'simple';
export const FAMILY_TYPE_INPADOC = 'inpadoc';
/**
 * 用于 patentFamily 的扩展参数
 */
export const EXTENDS_PARAM_NAME_FOR_PATENT_FAMILY = 'pf';

export const CACHE_KEY_FAMILY_TYPE = 'PATENT_FAMILY_TYPE';

export const CACHE_KEY_CHART_TYPE = 'PATENT_FAMILY_CHART_TYPE';

export const CACHE_KEY_TABLE_TYPE = 'PATENT_FAMILY_TABLE_TYPE';

export const CACHE_KEY_GEO_CHART_TYPE = 'PATENT_FAMILY_GEO_ChART_TYPE';

export const CACHE_KEY_IS_FULL_SCREEN = 'PATENT_FAMILY_IS_FULL_SCREEN_MODE';

export const CACHE_KEY_FAMILY_DISPLAY_FILTER = 'PATENT_FAMILY_DISPLAY_FILTER';
